import { render, staticRenderFns } from "./attendance-item.vue?vue&type=template&id=0c251cea&scoped=true"
import script from "./attendance-item.vue?vue&type=script&lang=js"
export * from "./attendance-item.vue?vue&type=script&lang=js"
import style0 from "./attendance-item.vue?vue&type=style&index=0&id=0c251cea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c251cea",
  null
  
)

export default component.exports